/**
 * TrendModa — Ultra-Reliable Infinite Scroll (v3.2 Singleton)
 */
(function() {
  'use strict';

  if (window.tmInfiniteInstance) {
    window.tmInfiniteInstance.init();
    return;
  }

  class TMInfiniteScroll {
    constructor() {
      this.isLoading = false;
      this.nextPageUrl = null;
      // Sayfanın altına bu kadar kala yüklemeye başla → kullanıcı için "anında" hissi
      this.TRIGGER_DISTANCE = 1200;
      this.io = null;
      this.idleCheckPending = false;
      this.loadedPageUrls = new Set();
      this.abortController = null;
      this.generation = 0;
      // scroll/resize yedeği (IO prerender/Safari'de tetiklenmezse devreye girer)
      this.checkHandler = this.rafThrottle(this.checkAndLoad.bind(this));
      this.eventsBound = false;

      this.init();
    }

    init() {
      this.generation += 1;
      if (this.abortController) this.abortController.abort();
      this.abortController = null;
      this.isLoading = false;
      const previousGrid = this.grid;
      this.grid = document.querySelector('#ProductGridContainer .ty-product-grid') || document.getElementById('product-grid');
      this.sentinel = document.getElementById('infinite-scroll-sentinel');
      this.loader = document.getElementById('infinite-scroll-loader');
      this.skeleton = document.getElementById('tm-skeleton-loader');
      this.container = document.getElementById('ProductGridContainer');
      this.pagination = this.container && this.container.querySelector('.tm-pagination-fallback');

      if (previousGrid && this.grid !== previousGrid) {
        this.loadedPageUrls.clear();
      }

      if (this.io) { this.io.disconnect(); this.io = null; }

      if (!this.grid || !this.sentinel) {
        this.nextPageUrl = null;
        return;
      }

      this.nextPageUrl = this.sentinel.dataset.nextUrl;
      if (!this.nextPageUrl) {
        if (this.loader) this.loader.style.display = 'none';
        if (this.skeleton) this.skeleton.style.display = 'none';
        return;
      }

      this.hideFallback();
      this.observeSentinel();
      this.bindEvents();
      // Sayfa kısa/sentinel zaten görünürse hemen yükle (IO'nun ilk tetiklemesini bekleme).
      // Tarayıcı boşta kalana kadar bekle: filtre sonrası grid'in tamamı yeniden render
      // edilirken erken bir getBoundingClientRect() çağrısı zorla senkron layout'a
      // (layout thrashing) yol açıp mobilde donma hissi yaratıyordu.
      this.scheduleIdleCheck();
    }

    scheduleIdleCheck() {
      if (this.idleCheckPending) return;
      this.idleCheckPending = true;
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => {
          this.idleCheckPending = false;
          this.checkAndLoad();
        }, { timeout: 500 });
      } else {
        requestAnimationFrame(() => requestAnimationFrame(() => {
          this.idleCheckPending = false;
          this.checkAndLoad();
        }));
      }
    }

    observeSentinel() {
      if (!('IntersectionObserver' in window) || !this.sentinel) return;
      this.io = new IntersectionObserver((entries) => {
        if (entries[0] && entries[0].isIntersecting) this.loadNextPage();
      }, { rootMargin: this.TRIGGER_DISTANCE + 'px 0px' });
      this.io.observe(this.sentinel);
    }

    bindEvents() {
      if (this.eventsBound) return;
      this.eventsBound = true;
      window.addEventListener('scroll', this.checkHandler, { passive: true });
      window.addEventListener('resize', this.checkHandler, { passive: true });
    }

    // IO tetiklemese bile sentinel tetik bölgesindeyse yükle
    checkAndLoad() {
      if (this.isLoading || !this.nextPageUrl || !this.sentinel) return;
      const rect = this.sentinel.getBoundingClientRect();
      if (!rect.width && !rect.height) return;
      if (rect.top <= window.innerHeight + this.TRIGGER_DISTANCE) {
        this.loadNextPage();
      }
    }

    async loadNextPage() {
      if (this.isLoading || !this.nextPageUrl) return;

      const fetchUrl = this.nextPageUrl;
      const generation = this.generation;
      const targetGrid = this.grid;
      const targetSkeleton = this.skeleton;
      const targetLoader = this.loader;
      if (this.loadedPageUrls.has(fetchUrl)) {
        this.finish();
        return;
      }
      this.loadedPageUrls.add(fetchUrl);

      this.isLoading = true;
      this.hideFallback();
      this.abortController = new AbortController();
      if (targetSkeleton) targetSkeleton.classList.add('is-loading');
      if (targetLoader) targetLoader.classList.add('is-loading');

      let appendedCount = 0;
      let advancedToNextPage = false;

      try {
        const response = await fetch(fetchUrl, { signal: this.abortController.signal });
        if (!response.ok) throw new Error(`HTTP Error: ${response.status}`);
        
        const html = await response.text();
        if (generation !== this.generation || targetGrid !== this.grid) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Only grab products that are actually inside the grid
        const newProducts = doc.querySelectorAll('#product-grid > .ty-card, #product-grid > .grid__item, #product-grid > .card-wrapper');
        const nextSentinel = doc.getElementById('infinite-scroll-sentinel');
        const nextPagination = doc.querySelector('.tm-pagination-fallback');
        
        if (newProducts.length > 0) {
          const fragment = document.createDocumentFragment();
          newProducts.forEach(product => {
            // Ensure we don't append duplicates
            const variantId = product.dataset.variantId;
            if (variantId && targetGrid.querySelector(`[data-variant-id="${variantId}"]`)) {
              return;
            }
            fragment.appendChild(product);
            appendedCount += 1;
          });
          if (appendedCount > 0) targetGrid.appendChild(fragment);
        }

        if (this.pagination && nextPagination) {
          this.pagination.innerHTML = nextPagination.innerHTML;
        }

        // Update the sentinel in the DOM
        const followingUrl = nextSentinel && nextSentinel.dataset.nextUrl;
        if (followingUrl && !this.loadedPageUrls.has(followingUrl)) {
          this.nextPageUrl = followingUrl;
          advancedToNextPage = true;
          if (this.sentinel) {
            this.sentinel.dataset.nextUrl = this.nextPageUrl;
          }
        } else {
          this.finish();
        }

        this.reinitTheme();

      } catch (err) {
        if (err.name === 'AbortError' || generation !== this.generation) return;
        this.loadedPageUrls.delete(fetchUrl);
        console.error('[TM InfiniteScroll] Failed:', err);
        this.showFallback('Ürünler otomatik yüklenemedi. Sonraki sayfaya aşağıdaki bağlantıdan geçebilirsiniz.');
      } finally {
        if (generation !== this.generation) return;
        this.isLoading = false;
        this.abortController = null;
        if (targetSkeleton) targetSkeleton.classList.remove('is-loading');
        if (targetLoader) targetLoader.classList.remove('is-loading');

        // Sentinel hâlâ tetik bölgesindeyse (büyük ekran/az ürün) bir sonraki sayfayı da getir
        if ((appendedCount > 0 || advancedToNextPage) && this.nextPageUrl) {
          this.scheduleIdleCheck();
        }
      }
    }

    hideFallback() {
      document.getElementById('tm-infinite-scroll-error')?.remove();
      if (this.pagination) this.pagination.hidden = true;
    }

    showFallback(message) {
      if (!this.pagination) return;
      this.pagination.hidden = false;
      let error = document.getElementById('tm-infinite-scroll-error');
      if (!error) {
        error = document.createElement('p');
        error.id = 'tm-infinite-scroll-error';
        error.className = 'tm-infinite-scroll-error';
        error.setAttribute('role', 'status');
        this.pagination.parentNode.insertBefore(error, this.pagination);
      }
      error.textContent = message;
    }

    finish() {
      this.nextPageUrl = null;
      if (this.io) { this.io.disconnect(); this.io = null; }
      this.teardownEvents();
      if (this.sentinel) this.sentinel.remove();
      if (this.loader) this.loader.remove();
      if (this.skeleton) this.skeleton.remove();
    }

    reinitTheme() {
      if (window.tmLazy && typeof window.tmLazy.initImageLazyLoad === 'function') {
        window.tmLazy.initImageLazyLoad();
      }
      if (window.tmWishlist && typeof window.tmWishlist.syncHearts === 'function') {
        window.tmWishlist.syncHearts();
      }
      document.dispatchEvent(new CustomEvent('collection:reloaded'));
    }

    rafThrottle(func) {
      let ticking = false;
      return () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { ticking = false; func(); });
      };
    }

    teardownEvents() {
      window.removeEventListener('scroll', this.checkHandler, { passive: true });
      window.removeEventListener('resize', this.checkHandler, { passive: true });
      this.eventsBound = false;
    }
  }

  // Create the singleton instance
  window.tmInfiniteInstance = new TMInfiniteScroll();

  // Watch for AJAX updates (Filtering/Sorting)
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type !== 'childList') continue;
      const currentGrid = document.querySelector('#ProductGridContainer .ty-product-grid') || document.getElementById('product-grid');
      if (currentGrid && currentGrid !== window.tmInfiniteInstance.grid) {
        window.tmInfiniteInstance.init();
        break;
      }
    }
  });

  const container = document.getElementById('ProductGridContainer');
  if (container) {
    observer.observe(container, { childList: true, subtree: true });
  }

})();
